import axios from '@/utils/request'

/* 支付方式 */
export function payType(data) {
  return axios({
    url: '/bhcoin/get_pay_type',
    method: 'post',
    data: data
  })
}

/* 平台币充值金额方式选择 */
export function ptbRecharge(data) {
  return axios({
    url: '/pay/ptb_recharge_give_programme',
    method: 'post',
    data: data
  })
}

/* 获取平台币充值订单 */
export function ptbOrder(data) {
  return axios({
    url: '/pay/get_ptb_recharge_order',
    method: 'post',
    data: data
  })
}

/* 平台币充值提交 */
export function ptbSub(data) {
  return axios({
    url: '/pay/ptb_recharge',
    method: 'post',
    data: data
  })
}

/* 获取扫码支付状态 */
export function scanStatus(data) {
  return axios({
    url: '/pay/query_ptb_recharge_status',
    method: 'post',
    data: data
  })
}

/* 获取扫码支付状态 押金 */
export function depositStatus(data) {
  return axios({
    url: '/pay/query_deposit_recharge',
    method: 'post',
    data: data
  })
}
//发送验证码

export function sendSms(data) {
  return axios({
    url: '/user/sendSms',
    method: 'post',
    data: data
  })
}

//绑定手机
export function bindPhone(data) {
  return axios({
    url: '/user/phone',
    method: 'post',
    data: data
  })
}

//实名认证
export function realauth(data) {
  return axios({
    url: '/user/realauth',
    method: 'post',
    data: data
  })
}

//绑定结算账户/修改登录密码/修改支付密码
export function updateFinal(data) {
  return axios({
    url: '/user/user_update_data',
    method: 'post',
    data: data
  })
}

//客服设置详情
export function serviceDetail(data) {
  return axios({
    url: '/user/customer_service_information',
    method: 'post',
    data: data
  })
}

//客服设置提交
export function serviceSub(data) {
  return axios({
    url: '/user/edit_customer_service_information',
    method: 'post',
    data: data
  })
}

//问题反馈
export function feedback(data) {
  return axios({
    url: '/user/feedback',
    method: 'post',
    data: data
  })
}

//佣金提现信息
export function commissionInfo(data) {
  return axios({
    url: '/pay/commission_info',
    method: 'post',
    data: data
  })
}

//平台币转移
export function ptbShift(data) {
  return axios({
    url: '/pay/ptb_shift',
    method: 'post',
    data: data
  })
}

//支付获取订单号
export function orderNum(data) {
  return axios({
    url: '/pay/get_deposit_recharge_order_num',
    method: 'post',
    data: data
  })
}

//押金支付
export function depositRecharge(data) {
  return axios({
    url: '/pay/deposit_recharge',
    method: 'post',
    data: data
  })
}

//佣金明细
export function commissionRecord(data, url) {
  return axios({
    url: url,
    method: 'post',
    data: data
  })
}

//佣金提现
export function commissionSubmit(data) {
  return axios({
    url: '/pay/commission_withdrawal_submit',
    method: 'post',
    data: data
  })
}

//押金等级
export function levelList(data) {
  return axios({
    url: '/pay/deposit_level',
    method: 'post',
    data: data
  })
}

//佣金寄售发送验证码
export function consignment_send_sms(data) {
  return axios({
    url: '/consignment/do_consignment_send_sms',
    method: 'post',
    data: data
  })
}

//佣金寄售获取订订单号
export function get_consignment_order(data) {
  return axios({
    url: '/consignment/get_consignment_order',
    method: 'post',
    data: data
  })
}

//佣金寄售提交
export function do_consignment(data) {
  return axios({
    url: '/consignment/do_consignment',
    method: 'post',
    data: data
  })
}

//佣金寄售记录
export function consignment_list(data) {
  return axios({
    url: '/consignment/list',
    method: 'post',
    data: data
  })
}


//修改佣金寄售状态
export function change_consignment_status(data) {
  return axios({
    url: '/consignment/change_status',
    method: 'post',
    data: data
  })
}

//贴牌配置
export function oem_config(data) {
  return axios({
    url: '/promote_customization/config',
    method: 'post',
    data: data
  })
}

//贴牌开通
export function promote_buy(data) {
  return axios({
    url: '/promote_customization/promote_buy',
    method: 'post',
    data: data
  })
}

//贴牌开通订单号
export function create_order(data) {
  return axios({
    url: '/promote_customization/create_order',
    method: 'post',
    data: data
  })
}

//贴牌查看支付状态
export function query_order_status(data) {
  return axios({
    url: '/promote_customization/query_order_status',
    method: 'post',
    data: data
  })
}

//贴牌提交
export function do_customize(data) {
  return axios({
    url: '/promote_customization/do_customize',
    method: 'post',
    data: data
  })
}

//获取贴牌配置
export function get_customize_config(data) {
  return axios({
    url: '/user/get_customize_config',
    method: 'post',
    data: data
  })
}

//第三方游戏列表
export function thirdlist(data) {
  return axios({
    url: '/gamethird/thirdlist',
    method: 'post',
    data: data
  })
}

//游戏类型
export function gametype(data) {
  return axios({
    url: '/gamethird/gametype',
    method: 'post',
    data: data
  })
}

//三方游戏添加
export function thirdadd(data) {
  return axios({
    url: '/gamethird/thirdadd',
    method: 'post',
    data: data
  })
}

//三方游戏删除
export function thirdDel(data) {
  return axios({
    url: '/gamethird/thirddel',
    method: 'post',
    data: data
  })
}

//三方游戏详情
export function thirddetail(data) {
  return axios({
    url: '/gamethird/thirddetail',
    method: 'post',
    data: data
  })
}

//三方游戏编辑提交
export function thirdedit(data) {
  return axios({
    url: '/gamethird/thirdedit',
    method: 'post',
    data: data
  })
}

//余额提现折扣
export function consignment_discount(data) {
  return axios({
    url: '/new_withdrawal/consignment_discount',
    method: 'post',
    data: data
  })
}

//余额提交发送验证码
export function yu_send_sms(data) {
  return axios({
    url: '/new_withdrawal/consignment_send_sms',
    method: 'post',
    data: data
  })
}

//余额提现提交
export function consignment_submit(data) {
  return axios({
    url: '/new_withdrawal/consignment_submit',
    method: 'post',
    data: data
  })
}

//余额发布列表
export function release_record(data) {
  return axios({
    url: '/new_withdrawal/release_record',
    method: 'post',
    data: data
  })
}

//余额提现修改状态
export function release_change_status(data) {
  return axios({
    url: '/new_withdrawal/release_change_status',
    method: 'post',
    data: data
  })
}

//余额发布列表
export function release_list(data) {
  return axios({
    url: '/new_withdrawal/release_list',
    method: 'post',
    data: data
  })
}

//余额下单
export function place_order(data) {
  return axios({
    url: '/new_withdrawal/place_order',
    method: 'post',
    data: data
  })
}

//余额购买记录
export function order_list(data) {
  return axios({
    url: '/new_withdrawal/order_list',
    method: 'post',
    data: data
  })
}

//余额上传支付截图
export function upload_pay_pic(data) {
  return axios({
    url: '/new_withdrawal/upload_pay_pic',
    method: 'post',
    data: data
  })
}

//平台币给玩家充值
export function recharge_user_ptb(data) {
  return axios({
    url: '/pay/recharge_user_ptb',
    method: 'post',
    data: data
  })
}

//平台币给玩家充值获取订单号(支付宝，微信)
export function get_user_ptb_recharge_order(data) {
  return axios({
    url: '/pay/get_user_ptb_recharge_order',
    method: 'post',
    data: data
  })
}

//平台币给玩家充值获取支付状态(支付宝，微信)
export function query_recharge_user_ptb(data) {
  return axios({
    url: '/pay/query_recharge_user_ptb',
    method: 'post',
    data: data
  })
}

//平台币给玩家充值记录
export function recharge_user_ptb_list(data) {
  return axios({
    url: '/pay/recharge_user_ptb_list',
    method: 'post',
    data: data
  })
}
//获取渠道隔离信息
export function promote_quarantine_info(data) {
  return axios({
    url: '/user/promote_quarantine_info',
    method: 'post',
    data: data
  })
}
//渠道隔离提交
export function promote_quarantine_set(data) {
  return axios({
    url: '/user/promote_quarantine_set',
    method: 'post',
    data: data
  })
}
//平台币收回提交
export function user_ptb_recovery(data) {
  return axios({
    url: '/pay/user_ptb_recovery',
    method: 'post',
    data: data
  })
}

//平台币收回记录
export function user_ptb_recovery_list(data) {
  return axios({
    url: '/pay/user_ptb_recovery_list',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/my.js